import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MembersUtilsService {
  getMemberStatusText(status: string) {
    switch (status) {
      case 'A':
        status = '[A]';
        break;
      case 'S':
        status = '**[Suspended]** &#x1F6A9;';
        break;
      case 'T':
        status = '**[Terminated]** &#x26a0;';
        break;
      case 'I':
        status = '**[Inactive]**';
        break;
      case 'X':
        status = '';
        break;
    }
    return status;
  }
}
